var api5Url, api3Url, cw1Url, pcUrl, href

href = window.location.href
 if (href.indexOf('//wwwyy.gx2.piscn.cn') > -1) {
    // 预上线英文域名
    api3Url = '//yyqxyapi.gx1.piscn.cn'
    cw1Url = 'http://wwwyy.gx2.piscn.cn'
    pcUrl = 'https://yyclien.gxzg.org.cn'
} else if (href.indexOf('www.qxy.tobh.cn') > -1) {
    api3Url = '//api3.qxy.tobh.cn'   //公信api
    cw1Url = 'http://www.qxy.tobh.cn' //企信易PC地址
    pcUrl = 'http://www4.gxnw.cn'  //公信PC站
} else if (href.indexOf('//www.qixinyi.cn') > -1 || href.indexOf('//xn--hoq2uw64c.xn--fiqs8s') > -1) {
    //正式机
    api3Url = 'https://api.qixinyi.cn'   //公信api
    cw1Url = 'https://www.qixinyi.cn' //企信易PC地址
    pcUrl = 'https://www.gxzg.org.cn'  //公信PC站
}else if (href.indexOf('//qixinyi.cn') > -1) {
    //正式机
    api3Url = 'https://api.qixinyi.cn'   //公信api
    cw1Url = 'https://www.qixinyi.cn' //企信易PC地址
    pcUrl = 'https://www.gxzg.org.cn'  //公信PC站
}else {
    api3Url = '/api3'   //公信api
    cw1Url = 'http://dev.qixinyi.cn' //企信易PC地址
    pcUrl = 'http://dev.gxzg.org.cn'  //公信PC站
}


// 环境
export default {
    /**
     * 全局变量
     */
    // objectBaseUrl: 'http://localhost:8080',
    apiCode: '110005', // 全局code
    apiKey: 'a1619fc4e7c3f62a', // 全局Key
    sign: 'a161b9399fc4b7dbe7c36c9bf62a7787', // 全局sign

    /**
     * 生产环境HOST
     */
    api3Url: api3Url,
    cw1Url: cw1Url,
    pcUrl: pcUrl
}



// WEBPACK FOOTER //
// ./src/page/cw/req/environment.js